
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Πατήστε «Άνοιγμα σε περιηγητή…»`,
's182ab2d6c997515f': `Προσθέστε το στην Οθόνη Αφετηρίας για εκτεταμένη εμπειρία και εύκολη πρόσβαση.`,
's224cbcec014ef6b5': `Πατήστε "Κοινή χρήση" στη γραμμή πλοήγησης`,
's233af3b7eb5e0364': `Προσθήκη στην αρχική σελίδα`,
's37a9e8aec5713460': `Περισσότερα`,
's4c3161035f3a1413': `Πατήστε το μενού`,
's4e1e10a6ca408245': `Πατήστε "Προσθήκη στην οθόνη Αφετηρίας"`,
's6196153c4b0c1ea0': `Εγκατάσταση`,
's633502f7cff4f847': `Ανοίξτε το μενού του περιηγητή σας`,
's681e399d63311fba': `Εμφάνιση συλλογής`,
's6d14a4f70ba4e3cf': `Πατήστε το μενού αν δεν υπάρχει εικονίδιο Κοινοποίησης`,
's922329d6f6213590': `Προσθήκη στο Dock`,
's9c63a79ffcc2a3a3': `Πατήστε "Προσθήκη στην οθόνη Αφετηρίας"`,
'sa2d71bfd9525168d': `Πατήστε "Προσθήκη στο Dock"`,
'sa5ef80b4bb9b39f8': `Λιγότερα`,
'sb527eca1c1d7e7be': `Ανοίξτε το μενού του ενσωματωμένου περιηγητή`,
'sba52286c21552a4e': `Εγκαταστήστε το στη συσκευή σας για εκτεταμένη εμπειρία και εύκολη πρόσβαση.`,
'sc16e00a7a8b2fde2': `Πίσω`,
'scdaf4bbff76674c8': `Προσθήκη στην οθόνη Αφετηρίας`,
'sd18a5b85f599ff3c': `Ανοίξτε τον αντιγραμμένο σύνδεσμο στο Safari`,
'se72fc3a84f9b51c3': `Πατήστε για αντιγραφή συνδέσμου`,
'se740f75b95a51807': `Προσθέστε το στο Dock για εκτεταμένη εμπειρία και εύκολη πρόσβαση.`,
'sfa6c42cdf48d93d2': `Ωστόσο, αυτός ο περιηγητής δεν υποστηρίζει αυτήν τη λειτουργία. Ανοίξτε τον σύνδεσμο σε εξωτερικό περιηγητή για να συνεχίσετε.`,
'sfb78526365796a41': `Πατήστε "Προβολή περισσότερων" στο μενού Κοινοποίησης`,
'sfea652f6580ff086': `Αυτός ο ιστότοπος έχει λειτουργικότητα εφαρμογής.`,
    };
  